import { z } from 'zod';

export type BoardFile = z.infer<typeof boardFileSchema>;
export const boardFileSchema = z.object({
    attachmentKey: z.string(),
    fileName: z.string(),
});
